import cn from 'classnames';
import React, { useEffect, useState } from 'react';

import { useModal } from '../hooks/modal';
import { domain } from '../utils/request';
import { usePutRequest } from '../hooks/request';
import { QQC_MONTHLY_ITEM_DETAIL } from '../urls';
import Button from './componentsFinance/common/Button';
import QqcMonthlyItemCreate from './QqcMonthlyItemCreate';
import QqcMonthlyItemUpdate from './QqcMonthlyItemUpdate';

export default function QqcMonthlyItemItem({ reportItems, finance, qqcMonthlyId, index, request }) {
	const reportItem = reportItems.filter(item => item.finance === finance.id)[0];

	const [showModal, hideModal] = useModal(
		<QqcMonthlyItemCreate
			onSuccess={() => {
				hideModal();
				request();
			}}
			qqcMonthlyId={qqcMonthlyId}
			finance={finance}
			onCancel={() => hideModal()}
		/>
	);

	const [showUpdateModal, hideUpdateModal] = useModal(
		<QqcMonthlyItemUpdate
			onSuccess={() => {
				hideUpdateModal();
				request();
			}}
			reportItem={reportItem}
			qqcMonthlyId={qqcMonthlyId}
			finance={finance}
			onCancel={() => hideModal()}
		/>
	);
	function onSubmit() {
		if (reportItem) {
			showUpdateModal();
			return;
		}
		showModal();
	}

	const [taxStatus, setTaxStatus] = useState(reportItem && reportItem.tax ? reportItem.tax : false);
	const url = QQC_MONTHLY_ITEM_DETAIL.replace('{id}', reportItem?.id);
	const qqcMonthlyItemUpdate = usePutRequest({ url });

	useEffect(() => {
		setTaxStatus(reportItem && reportItem.tax ? reportItem.tax : false);
	}, [reportItem]);

	async function onUpdateTax(status) {
		const { success } = await qqcMonthlyItemUpdate.request({ data: { tax: status } });
		if (success) {
			request();
		}
	}

	function handleTaxStatusChange(event) {
		const newTaxStatus = event.target.checked;
		setTaxStatus(newTaxStatus);
		onUpdateTax(newTaxStatus);
	}

	return (
		<tr className='pl-3 pr-3'>
			<td className='has-text-centered'>{index + 1}</td>
			{reportItem ? <td className={cn('has-text-centered has-text-black')}>{finance.name}</td> : <td className={cn('has-text-centered has-text-danger')}>{finance.name}</td>}
			<td className='has-text-centered'>{finance.stir}</td>
			<td className='has-text-centered'>{finance.directorStir}</td>
			{reportItem ? (
				<td className='has-text-centered'>
					<a className='has-text-black tag is-info is-light' href={domain + reportItem.qqcMonthlyPdf}>
						Скачать
					</a>
				</td>
			) : (
				<td className='has-text-centered'>Пусто</td>
			)}
			{reportItem ? <td className='has-text-centered'>{reportItem.qqcMonthlyComment}</td> : <td className='has-text-centered'>Пусто</td>}
			<td className='has-text-centered'>
				<input style={{ width: 22, height: 22 }} type='checkbox' checked={taxStatus} onChange={handleTaxStatusChange} />
			</td>
			<td>
				<Button onClick={onSubmit} className={reportItem ? 'button is-success is-light' : 'button is-danger is-light'} icon={reportItem ? 'icon ion-md-create' : 'icon ion-md-add'} text={reportItem ? 'Обновить' : 'Добавить'} />
			</td>
		</tr>
	);
}
